/**
 * Main category of product.
 */
export type ProductMainCategory = 'DRINKS';

export const ProductMainCategory = {
  Drinks: 'DRINKS' as ProductMainCategory,
};
